import { TrefikHttpClient } from "@/api/trefik-api-http-client";
import removeAccents from "@/shared/utils/remove-accents";
import type { TrefikParams, TrefikLeagues } from "@/prematch/model/trefik/trefik-base";
import { TrefikStatsUniversal } from "@/prematch/model/trefik/trefik-universal";
import { EventTrefik } from "@/prematch/model/trefik/trefik-event-universal";

export const normalizeParams = (params: TrefikParams) => {
    const newParams = {};
    Object.keys(params).forEach((key) => {
        if (!params[key]) return;
        newParams[key] = removeAccents(params[key])
            .trim()
            .toLowerCase()
            .replaceAll(/\s+/g, "-")
            .replaceAll(/\/+/g, "-")
            .replaceAll(/\.+/g, "-")
            .replaceAll(/,+/g, "-");
    });
    return newParams as TrefikParams;
};

const buildTrefikPath = (params: TrefikParams) => {
    const { sport, league, event } = normalizeParams(params);
    let statsPath = `/stats`;
    if (event) {
        statsPath = `${statsPath}/${event}`;
    } else if (sport && league) {
        statsPath = `${statsPath}/${sport}/${league}`;
    } else {
        console.error("Invalid params for trefik");
    }
    return statsPath;
};

export async function getTrefikLeagues(): Promise<TrefikLeagues> {
    const response = await TrefikHttpClient.get(`/stats/listSportsLeagues`);
    return response?.data;
}

const fetchTrefikData = async <T>(params: TrefikParams): Promise<T> => {
    const response = await TrefikHttpClient.get(buildTrefikPath(params));
    if (!response?.data) return undefined;
    return response.data;
};

export async function getTrefikLeagueStats(params: TrefikParams): Promise<TrefikStatsUniversal> {
    return fetchTrefikData<TrefikStatsUniversal>(params);
}

export async function getTrefikMatchStats(params: TrefikParams): Promise<EventTrefik> {
    return fetchTrefikData<EventTrefik>(params);
}
